import { getNumOfreadReport } from '../../service'
const user_main_mixin = {
  data() {
    return {
      had_read_report: [],
    }
  },
  methods: {
    go(item, type) {
      if (type == 1) {
        const href = this.$store.state.index2_path + '/newsDetail/' + item.uid
        window.open(href, '_blank')
      } else if (type == 2) {
        const { href } = this.$router.resolve({name: "ReportDetail", params: {uid: item.uid}})
        window.open(href, '_blank')
      } else if (type == 3) {
        const { href } = this.$router.resolve({name: "SpecialDetail", params: {uid: item.uid}})
        window.open(href, '_blank')
      } else if (type == 4) {
        const { href } = this.$router.resolve({name: "PolicyDetail", params: {uid: item.uid}})
        window.open(href, '_blank')
      } else if (type == 5) {
        window.open(this.$store.state.index2_path + '/' + item.id)
      }
    },
    /**
     * 统计用户查看的免费报告篇数
     */
    async getNumOfreadReport(uid) {
      let res = await getNumOfreadReport( {user_key: this.$store.state.user_key}, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        if(res.res < 10 || this.isVIP) {
          let q = JSON.stringify({user_key: this.user_key, uid: uid})
          window.open(this.$store.state.req_url + '/dg/reportfile?query=' + q)
        } else {
          this.showModal()
        }
        this.had_read_report = res.report_ids
      } else {
        this.$Message.error(res.message)
      }
    }
  }
}

export { user_main_mixin }
